import {
  AddProfessionalSkillDocument,
  ProfessionalSkills as ProfessionalSkillsT,
} from '@/types/graphql/types'
import { getErrorMessage } from '@/util/getErrorMessage'
import { useMutation } from '@apollo/client'
import { useForm } from '@mantine/form'
import { useModals } from '@mantine/modals'
import { showNotification } from '@mantine/notifications'
import { parseInt, toString } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const useSkillsForm = ({
  ps,
  handleUpdatePs,
}: {
  ps: ProfessionalSkillsT | null
  handleUpdatePs: ({ newPS }: { newPS: ProfessionalSkillsT[] }) => void
}) => {
  const { t } = useTranslation('common')
  const { query } = useRouter()
  const modals = useModals()

  const form = useForm({
    initialValues: {
      academicRank: toString(ps?.academicRank?.id) || '-',
      natureOfWork: ps?.natureOfWork,
      placeOfWork: ps?.placeOfWork,
      type: ps?.type,
      yearsOfExperience: ps?.yearsOfExperience,
    },
  })
  // skills mutation
  const [mutatePs, { loading }] = useMutation(AddProfessionalSkillDocument, {
    onCompleted(data) {
      handleUpdatePs({
        newPS: data.AddProfessionalSkill as ProfessionalSkillsT[],
      })
      modals.closeAll()
      showNotification({
        title: t('updated'),
        message: t('updatedSuccessfully'),
      })
    },
    onError(error) {
      showNotification({
        title: t('error'),
        message: getErrorMessage(error),
        color: 'red',
        autoClose: false,
      })
    },
  })
  //submit skills data
  const submit = (values: typeof form.values) => {
    if (ps === null) {
      // create
      mutatePs({
        variables: {
          data: {
            ProfessionalSkill: {
              academicRank: values.academicRank
                ? {
                    connect: {
                      id: parseInt(values.academicRank),
                    },
                  }
                : undefined,
              natureOfWork: values.natureOfWork ?? undefined,
              placeOfWork: values.placeOfWork ?? undefined,
              type: values.type ?? undefined,
              yearsOfExperience: values.yearsOfExperience ?? undefined,
            },
            userId: parseInt(query.id as string),
          },
        },
      })
    } else {
      // update
      mutatePs({
        variables: {
          data: {
            ProfessionalSkill: {
              academicRank: values.academicRank
                ? {
                    connect: {
                      id: parseInt(values.academicRank),
                    },
                  }
                : undefined,
              natureOfWork: values.natureOfWork ?? undefined,
              placeOfWork: values.placeOfWork ?? undefined,
              type: values.type ?? undefined,
              yearsOfExperience: values.yearsOfExperience ?? undefined,
            },
            userId: parseInt(query.id as string),
            ProfessionalSkillId: ps.id,
          },
        },
      })
    }
  }
  return {
    form,
    submit,
    loading,
  }
}

export default useSkillsForm
